<script lang="ts">
	const payouts = [
		{ level: "1st Referral Purchased:", amount: "$500" },
		{ level: "2nd Referral Purchased:", amount: "$1,000" },
		{ level: "3rd Referral Purchased:", amount: "$2,000" },
		{ level: "4th Referral Purchased:", amount: "$4,000" }
	];
</script>

<div class="animate-fade-in-up-delay-4 rounded-lg border bg-white p-6 shadow-sm">
	<h3 class="text-foreground mb-2 text-xl font-semibold">Compound your Payouts!</h3>
	<p class="mb-6 text-gray-600">
		Every property we buy from your submittal creates a stacking payout that resets yearly!
	</p>

	<div class="space-y-3">
		{#each payouts as payout}
			<div
				class="bg-border/30 hover:bg-border/50 flex justify-between rounded-lg border p-3 transition-colors duration-200"
			>
				<span class="text-gray-700">{payout.level}</span>
				<span class="text-primary font-semibold">{payout.amount}</span>
			</div>
		{/each}
	</div>

	<p class="text-foreground mt-6 font-medium">
		Any additional referrals purchased for the year, $4,000 each!
	</p>
</div>
